// extracted by mini-css-extract-plugin
module.exports = {"overdue":"Milestone_overdue__3e5n-","finished":"Milestone_finished__OXU1D"};